<div class="main-container">
  <div class="page-info">
    <h3 class="title">
      <!-- Business Name and Address -->
      {{ "advanced-pages.business-info.businessname-title" | i18next }}
      <span class="required-mark">*</span>
    </h3>
    <p class="note tw-pt-4">
      {{ "advanced-pages.business-info.businessname-description" | i18next }}
      <!-- Provide your registered business name and address as shown in business
      documents, bills, etc. -->
    </p>
  </div>

  <app-reactive-text-field2
    [label]="'advanced-pages.business-info.business-name-input' | i18next"
    [required]="true"
    [control]="businessInfoForm.controls['businessName']"
    reference="no-white-space"
  ></app-reactive-text-field2>

  <div class="checkbox-container">
    <input
      type="checkbox"
      id="same-as-pickup"
      [formControl]="businessInfoForm.controls['sameAsPickup']"
    />
    <label for="same-as-pickup">{{
      "advanced-pages.business-info.pickup-checkbox" | i18next
    }}</label>
  </div>
  <app-reactive-ng-select-field
    [placeholder]="'advanced-pages.business-info.province' | i18next"
    bindLabel="name"
    id="province"
    appearance="outline"
    dropdownPosition="bottom"
    appendTo="app-root"
    [options]="provinceQuery.data() ?? []"
    [loading]="provinceQuery.isFetching()"
    [formControl]="businessInfoForm.controls['province']"
    [validationMessage]="validationMessages"
    [errors]="getFieldError(businessInfoFormKeys.province)"
    [required]="true"
  />
  <app-reactive-ng-select-field
    [placeholder]="'advanced-pages.business-info.city' | i18next"
    bindLabel="name"
    id="city"
    appearance="outline"
    dropdownPosition="bottom"
    appendTo="app-root"
    [options]="cityQuery.data() ?? []"
    [loading]="cityQuery.isFetching()"
    [formControl]="businessInfoForm.controls['city']"
    [validationMessage]="validationMessages"
    [errors]="getFieldError(businessInfoFormKeys.city)"
    [required]="true"
  />
  <app-reactive-ng-select-field
    [placeholder]="'advanced-pages.business-info.barangay' | i18next"
    bindLabel="name"
    id="barangay"
    appearance="outline"
    dropdownPosition="bottom"
    appendTo="app-root"
    [options]="barangayQuery.data() ?? []"
    [loading]="barangayQuery.isFetching()"
    [formControl]="businessInfoForm.controls['barangay']"
    [validationMessage]="validationMessages"
    [errors]="getFieldError(businessInfoFormKeys.barangay)"
    [required]="true"
  />

  <app-reactive-text-field2
    [label]="'advanced-pages.business-info.zipcode' | i18next"
    [required]="true"
    inputType="number"
    type="number"
    [control]="businessInfoForm.controls['zipCode']"
    reference="zipCode"
  ></app-reactive-text-field2>

  <app-reactive-text-field2
    [label]="'advanced-pages.business-info.street-input' | i18next"
    [required]="true"
    [control]="businessInfoForm.controls['line1']"
    reference="line_1"
  />

  <!-- <div
    class="tw-fixed tw-bottom-0 tw-left-0 tw-px-5 tw-py-4 tw-gap-4 tw-w-full bottom-bar"
  >   

  </div> -->
</div>
<app-cta-buttons
  currentPage="business-info"
  [backButton]="false"
  [pageNames]="advancedPages"
  [nextCallback]="handleNextClick"
  tier="advanced"
  [disabled]="businessInfoForm.invalid"
  (nextEvent)="handleNextClick()"
></app-cta-buttons>
